module.exports = __webpack_public_path__ + "static/media/Quy hoach xay dung.11983c03.png";